import { Component, OnInit, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatSnackBar
} from '@angular/material';
import { PreSignService } from '../../../../shared/services/preSign.service';
import { LocalUserService } from '../../../../shared/services/localUser';
import { UserService } from '../../../../shared/services/user.service';
import { CognitoUtil } from '../../../../shared/services/cognito.service';
import { CaseService } from '../../../../shared/services/case.service';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators
} from '@angular/forms';
import { Role } from '../../../../shared/models/role';
import { ConfirmationDialogComponent } from '../../../../shared/dialog/confirmation-dialog/confirmation-dialog.component';
import { CheckrService } from '../../../../shared/services/checkr.service';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-payment-pref-dialog-component',
  templateUrl: './payment-pref-dialog-component.component.html',
  styleUrls: ['./payment-pref-dialog-component.component.scss'],
  providers: [LocalUserService, PreSignService]
})
export class PaymentPrefDialogComponent implements OnInit {
  userData: any;
  token: string;
  userID: string;
  userRole: string;
  stripeAchBankForm: FormGroup;
  loading: boolean;
  stripeAchBankFormErrors = [];
  paymentPreferenceJson = {
    paymentType: null,
    bankToken: null
  };
  stripeRef: any = (<any>window).Stripe(environment.stripePublishableKey); // publishable key is required
  elements: any = this.stripeRef.elements();
  constructor(
    public dialogRef: MatDialogRef<PaymentPrefDialogComponent>,
    public dialog: MatDialog,
    private caseService: CaseService,
    private cognito: CognitoUtil,
    private userService: UserService,
    private checkrService: CheckrService,

    private localUser: LocalUserService,
    private preSign: PreSignService,
    public snackBar: MatSnackBar,
    public fb: FormBuilder,
    public router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    let userSaved = this.localUser.getUser();
    let defaultPaymentTypeToSet =
      userSaved && userSaved.paymentPref
        ? this.userService.getPaymentPrefValueToSet(
          userSaved.paymentPref.paymentPreferred.toString()
        )
        : null;
    let defaultAchTypeToSet = null;
    if (defaultPaymentTypeToSet == null) {
      defaultPaymentTypeToSet = 'CC';
    } else {
      if (defaultPaymentTypeToSet.indexOf('ACH') !== -1) {
        defaultAchTypeToSet = defaultPaymentTypeToSet;
        defaultPaymentTypeToSet = 'ACH';
      }
    }
    this.stripeAchBankForm = new FormGroup({
      paymentType: new FormControl(defaultPaymentTypeToSet, [
        Validators.required
      ]),
      achType: new FormControl(defaultAchTypeToSet),
      account_holder_type: new FormControl('individual'), // TODO delete hard-coded
      account_number: new FormControl(''), // TODO delete hard-coded
      routing_number: new FormControl(''), // TODO delete hard-coded
      country: new FormControl('US'),
      currency: new FormControl('USD'),
      account_holder_name: new FormControl('') // TODO delete hard-coded
    });
    this.userID = this.localUser.getUserId();
    this.userRole = this.localUser.getRole();
  }
  generateStripeBankAccountToken() {
    let that = this;
    this.loading = true;
    let accountNo = this.stripeAchBankForm.value.account_number;
    if (accountNo) {
      accountNo = this.padDigits(accountNo, 12);
    }
    let stripeBankAccountJson = {
      account_holder_type:
        '' + this.stripeAchBankForm.value.account_holder_type + '',
      routing_number: '' + this.stripeAchBankForm.value.routing_number + '',
      account_number: '' + accountNo + '',
      currency: '' + this.stripeAchBankForm.value.currency + '',
      country: '' + this.stripeAchBankForm.value.country + '',
      account_holder_name: '' + this.stripeAchBankForm.value.account_holder_name + ''
    };
    // TODO: delete hard coded to test bank
    // stripeBankAccountJson = {
    //   country: 'US',
    //   currency: 'usd',
    //   routing_number: '110000000',
    //   account_number: '000123456789',
    //   account_holder_name: 'Jenny Rosen',
    //   account_holder_type: 'individual'
    // };
    this.stripeRef
      .createToken('bank_account', stripeBankAccountJson)
      .then(function (result) {
        console.log('ACH Bank Account result--\n');
        console.log('result-- ' + JSON.stringify(result));
        console.log(stripeBankAccountJson);
        that.loading = false;
        if (result && result.token) {
          that.paymentPreferenceJson.bankToken = result.token.id;
          that.paymentPrefCall();
        }
        if (result.error) {
          console.error('Got error in bank token');
          console.error(result.error);
          that.stripeAchBankFormErrors.push(result.error.message);
        }
      });
  }
  paymentPrefCall() {
    this.loading = true;
    console.log('In paymentPrefCall');
    console.log(this.paymentPreferenceJson);
    this.userService
      .postUserPaymentPreferences(this.userID, this.paymentPreferenceJson)
      .subscribe(preferenceSaved => {
        this.loading = false;
        let successMsg = 'Payment preference saved successfully.';
        console.log(successMsg);
        this.snackBar.open(successMsg, null, {
          extraClasses: ['success-snackbar'],
          duration: 5000
        });
        // To get again user preferences and update in UI storage
        this.getUserDetails();
      });
    this.loading = false;
  }
  paymentPreferenceSubmit() {
    this.loading = true;
    this.stripeAchBankFormErrors = [];
    let bankAccountToken = null;
    let selectedPaymentType = this.stripeAchBankForm.value.paymentType;
    this.paymentPreferenceJson.paymentType = selectedPaymentType;
    if (selectedPaymentType === 'ACH') {
      let selectedAchType = this.stripeAchBankForm.value.achType;
      this.paymentPreferenceJson.paymentType = selectedAchType;
    }
    if (this.paymentPreferenceJson.paymentType === 'ACH_MICRO') {
      this.generateStripeBankAccountToken();
    } else {
      this.paymentPrefCall();
    }
    // this.loading = false;
  }
  closePaymentDialog() {
    this.dialogRef.close(true);
  }

  getUserDetails() {
    let userObjectSaved = this.localUser.getUser();
    this.userService.getUserPrefrence(userObjectSaved.id).subscribe(result => {
      userObjectSaved = this.userService.convertUserObjectToModel(result, userObjectSaved);
      localStorage.setItem('userDetails', JSON.stringify(userObjectSaved));
      // this.router.navigate(['/settings']);
      this.closePaymentDialog();
    });
  }

  // This is to add pre '0' digit in accountnumber
  padDigits(number, digits) {
    return Array(Math.max(digits - String(number).length + 1, 0)).join('0') + number;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/dialogs/payment-pref-dialog-component/payment-pref-dialog-component.component.ts